import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="daily-goals"
export default class extends Controller {
  static targets = ["container"];
  count = 0;

  connect() {
    if (this.containerTarget.children.length === 0) {
      this.addGoal();
    }
  }

  addGoal() {
    this.count += 1;

    const template = document.getElementById("input-template");
    const newInputContainer = template.content.cloneNode(true);

    const label = newInputContainer.querySelector("label");
    const input = newInputContainer.querySelector("input");

    label.setAttribute("for", `daily-goal-${this.count}`);
    input.setAttribute("id", `daily-goal-${this.count}`);

    this.containerTarget.appendChild(newInputContainer);
  }

  deleteGoal(event) {
    const inputContainer = event.target.closest(".input-container");
    if (inputContainer) {
      inputContainer.remove();
    }
  }
}
